import { useNavigate } from "react-router-dom";
import lobbyImg from "./assets/lobby.jpeg";

function Lobby() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${lobbyImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
      }}
    >
      {/* Classroom Link */}
      <div
        onClick={() => navigate("/classroom")}
        style={{
          position: "absolute",
          right: "18%",
          top: "35%",
          background: "rgba(255,255,255,0.85)",
          padding: "10px 18px",
          borderRadius: "20px",
          cursor: "pointer",
          fontWeight: "bold",
          color: "#1e40af",
        }}
      >
        👉 Go to Classroom
      </div>

      {/* Reception Link */}
      <div
        onClick={() => navigate("/reception")}
        style={{
          position: "absolute",
          left: "20%",
          top: "45%",
          background: "rgba(255,255,255,0.85)",
          padding: "10px 18px",
          borderRadius: "20px",
          cursor: "pointer",
          fontWeight: "bold",
          color: "#047857",
        }}
      >
        👉 Go to Reception
      </div>
    </div>
  );
}

export default Lobby;
